import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { ApiBlueprint, type ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
} from '@backstage/core-compat-api';
import {
  githubActionsPlugin,
  EntityGithubActionsContent,
  githubActionsApiRef,
  GithubActionsClient,
} from '@backstage/plugin-github-actions';
import { configApiRef } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';

const routeRef = githubActionsPlugin.routes?.entityContent;

export const githubActionsApi = ApiBlueprint.make({
  name: 'github-actions-api',
  params: defineParams =>
    defineParams({
      api: githubActionsApiRef,
      deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
      factory: ({
        configApi,
        scmAuthApi,
      }: {
        configApi: typeof configApiRef.T;
        scmAuthApi: typeof scmAuthApiRef.T;
      }) => new GithubActionsClient({ configApi, scmAuthApi }),
    }),
});

const githubActionsContent: ExtensionDefinition = EntityContentBlueprint.make({
  name: 'githubActionsContent',
  params: {
    path: '/github-actions',
    title: 'CI/CD',
    routeRef: routeRef ? convertLegacyRouteRef(routeRef) : undefined,
    loader: async () =>
      compatWrapper(<EntityGithubActionsContent />),
  },
});
export default githubActionsContent;

